// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CreateClaimRequestModel {
    'accountId': number;
    'documentIds'?: Array<number>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CreateClaimRequestModel>> = [
        {
            "name":     "accountId",
            "baseName": "accountId",
            "type":     "number"
        },
        {
            "name":     "documentIds",
            "baseName": "documentIds",
            "type":     "Array<number>"
        },
    ];

    static getAttributeTypeMap() {
        return CreateClaimRequestModel.attributeTypeMap;
    }
}
